/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Style_Preset_Save_TitleInputs */



/**
* | output |
* | --- |
* | "Save Style Preset" |
*
* @param {Image_Export_Style_Preset_Save_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_style_preset_save_title = /** @type {((inputs?: Image_Export_Style_Preset_Save_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Style_Preset_Save_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer le prereglage de style")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stilvoreinstellung speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva stile predefinito")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранить предустановку стиля")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar estilo preestablecido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存样式预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイルプリセットを保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्टाइल प्रीसेट सहेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar predefinição de estilo")
	return /** @type {LocalizedString} */ ("Save Style Preset")
});